import React, { useState } from "react";
import "./bilty.css";
import { Button } from "@mui/material";
import Printbilty from "./Printbilty";
import { useSelector } from "react-redux";
function Invoices({ data = {}, isEdit = false, onUpdate = () => {} }) {
  // local storage data

  const jsonDataString = window.localStorage.getItem("jsonData");
  const ewayBillString = window.localStorage.getItem("ewayBillJson");

  const jsonData = JSON.parse(jsonDataString);
  const ewayBillData = JSON.parse(ewayBillString);

  const biltyReducer = useSelector((state) => state.biltyReducer.bilty);
  console.log("biltyReducer : ", biltyReducer);

  // const [details, setdetails] = useState({
  //   from: "",
  //   to: "",
  //   truck_no: "",
  //   consignor: "",
  //   consignor_address: "",
  //   challan_number: "",
  //   gst_no: "",
  //   consignee: "",
  //   consignee_gst_no: "",
  //   consignee_address1: "",
  //   consignee_address2: "",
  //   packing: "",
  //   gp_no: "",
  //   description: "",

  //   weight: "",
  //   rate_per_mt: "",
  //   freight_to_pay: "",
  //   advance: "",
  //   rate_cgst_sgst: "",
  //   rate_igst: "",
  //   total: "",
  //   to_pay_remarks: "",
  //   eWay_Bill_No: "",
  // });

  const [details, setdetails] = useState(() => {
    if (!isEdit) {
      return {
        from: biltyReducer.from || "",
        to: biltyReducer.to || "",
        truck_no: biltyReducer.truck_no || "",
        consignor: biltyReducer.consignor || "",
        consignor_address: biltyReducer.consignor_address || "",
        challan_number: biltyReducer.challan_number || "",
        gst_no: biltyReducer.gst_no || "",
        consignee: biltyReducer.consignee || "",
        consignee_gst_no: biltyReducer.consignee_gst_no || "",
        consignee_address1: biltyReducer.consignee_address1 || "",
        consignee_address2: biltyReducer.consignee_address2 || "",
        packing: biltyReducer.packing || "",
        gp_no: biltyReducer.gp_no || "",
        invoice_no: biltyReducer.invoice_no || "",
        invoice_date: biltyReducer.invoice_date || "",
        description: biltyReducer.description || "",
        weight: biltyReducer.weight || "",
        rate_per_mt: biltyReducer.rate_per_unit || "",
        freight_to_pay: biltyReducer.freight_to_pay || "",
        advance: biltyReducer.advance || "",
        rate_cgst_sgst: biltyReducer.rate_cgst_sgst || "",
        rate_igst: biltyReducer.rate_igst || "",
        total: biltyReducer.total || "",
        to_pay_remarks: biltyReducer.to_pay_remarks || "",
        eWay_Bill_No: biltyReducer.eWay_Bill_No || "",
      };
    } else {
      return {
        from: data.from || "",
        to: data.to || "",
        truck_no: data.truck_no || "",
        consignor: data.consignor || "",
        consignor_address: data.consignor_address || "",
        challan_number: data.challan_number || "",
        gst_no: data.gst_no || "",
        consignee: data.consignee || "",
        consignee_gst_no: data.consignee_gst_no || "",
        consignee_address1: data.consignee_address1 || "",
        consignee_address2: data.consignee_address2 || "",
        packing: data.packing || "",
        gp_no: data.gp_no || "",
        invoice_no: data.invoice_no || "",
        invoice_date: data.invoice_date || "",
        description: data.description || "",
        weight: data.weight || "",
        rate_per_mt: data.rate_per_unit || "",
        freight_to_pay: data.freight_to_pay || "",
        advance: data.advance || "",
        rate_cgst_sgst: data.rate_cgst_sgst || "",
        rate_igst: data.rate_igst || "",
        total: data.total || "",
        to_pay_remarks: data.to_pay_remarks || "",
        eWay_Bill_No: data.eWay_Bill_No || "",
      };
    }
  });

  // clear form function

  const handleClearData = () => {
    setdetails({
      from: "",
      to: "",
      truck_no: "",
      consignor: "",
      consignor_address: "",
      challan_number: "",
      gst_no: "",
      consignee: "",
      consignee_gst_no: "",
      consignee_address1: "",
      consignee_address2: "",
      packing: "",
      gp_no: "",
      invoice_no: "",
      invoice_date: "",
      description: "",
      weight: "",
      rate_per_mt: "",
      freight_to_pay: "",
      advance: "",
      rate_cgst_sgst: "",
      rate_igst: "",
      total: "",
      to_pay_remarks: "",
      eWay_Bill_No: "",
    });
  };

  // retrive data from E-way form

  const handleRetrieveData = () => {
    if (jsonData || ewayBillData) {
      const retrievedFormData = {
        from: "",
        to: "",
        truck_no: ewayBillData?.vehicleNo || "",
        consignor: "",
        consignor_address: "",
        challan_number: "",
        gst_no: "",
        consignee: "",
        consignee_gst_no: "",
        consignee_address1: "",
        consignee_address2: "",
        packing: "",
        invoice_no: "",
        invoice_date: "",
        description: "",
        weight: ewayBillData?.quantity || "",
        rate_per_mt: ewayBillData?.rate || "",
        freight_to_pay: "",
        advance: "",
        rate_cgst_sgst: ewayBillData?.sgstRate || "",
        rate_igst: ewayBillData?.igstRate || "",
        total: "",
        to_pay_remarks: "",
        eWay_Bill_No: jsonData?.data?.ewayBillNo || "",
      };
      setdetails(retrievedFormData);
    }
  };

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log(details);
    // const response = await fetch(`http://localhost:5000/bilty/`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(details),
    // });

    //data from session storage
    if (!isEdit) {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/bilty/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify(details),
        }
      );
      const json = await response.json();
      console.log("json : ", json);
      console.log("edit", isEdit);
      const inputfield = document.getElementsByClassName("entry");

      Object.entries(inputfield).forEach((element) => {
        console.log(element[1].value);
        element[1].value = ""; //
      });
      document.getElementById("biltyform").classList.toggle("c-form");
      document.getElementById("bilty-template").classList.toggle("jadu");
    } else {
      // PUT request for updating the existing entry
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/bilty/${data.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify(details),
        }
      );

      const json = await response.json();
      console.log("json:", json);
      console.log("edit", isEdit);
      onUpdate(details);
      document.getElementById("biltyform").classList.toggle("c-form");
      document.getElementById("bilty-template").classList.toggle("jadu");
    }
  };
  return (
    <div className="bilty">
      <form
        action=""
        id="biltyform"
        className="biltyform"
        onSubmit={handleSubmit}
      >
        <Button
          type="button"
          style={{
            marginLeft: "100px",
            marginRight: "100px",
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleClearData}
        >
          Clear Form
        </Button>
        {"  "}
        <Button
          type="button"
          style={{
            marginLeft: "100px",
            marginRight: "100px",
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleRetrieveData}
        >
          Retrieve Data
        </Button>
        <label style={{ marginTop: "10px" }}>
          From:
          <input
            className="entry"
            type="text"
            name="from"
            value={details.from}
            onChange={handleChange}
          />
        </label>
        <label>
          To:
          <input
            type="text"
            className="entry"
            name="to"
            value={details.to}
            onChange={handleChange}
          />
        </label>
        <label>
          Eway-Bill Number:
          <input
            type="text"
            className="entry"
            name="eWay_Bill_No"
            value={details.eWay_Bill_No}
            onChange={handleChange}
          />
        </label>
        <label>
          Truck Number:
          <input
            type="text"
            className="entry"
            name="truck_no"
            value={details.truck_no}
            onChange={handleChange}
          />
        </label>
        <label>
          challan Number:
          <input
            type="text"
            className="entry"
            name="challan_number"
            value={details.challan_number}
            onChange={handleChange}
          />
        </label>
        <label>
          Consignor :
          <input
            type="text"
            className="entry"
            name="consignor"
            value={details.consignor}
            onChange={handleChange}
          />
        </label>
        <label>
          Address :
          <input
            type="text"
            className="entry"
            name="consignor_address"
            value={details.consignor_address}
            onChange={handleChange}
          />
        </label>
        <label>
          GST No :
          <input
            type="text"
            className="entry"
            name="gst_no"
            value={details.gst_no}
            onChange={handleChange}
          />
        </label>
        <label>
          Consignee :
          <input
            type="text"
            className="entry"
            name="consignee"
            value={details.consignee}
            onChange={handleChange}
          />
        </label>
        <label>
          Consignee-Gst No :
          <input
            type="text"
            className="entry"
            name="consignee_gst_no"
            value={details.consignee_gst_no}
            onChange={handleChange}
          />
        </label>
        <label>
          Address :
          <input
            type="text"
            className="entry"
            name="consignee_address1"
            value={details.consignee_address1}
            onChange={handleChange}
          />
          <input
            type="text"
            className="entry"
            name="consignee_address2"
            value={details.consignee_address2}
            onChange={handleChange}
          />
        </label>
        <label>
          Method Of Packing :
          <input
            type="text"
            className="entry"
            name="packing"
            value={details.packing}
            onChange={handleChange}
          />
        </label>
        <label>
          Description (Said To Contain):
          <input
            type="text"
            className="entry"
            name="description"
            value={details.description}
            onChange={handleChange}
          />
        </label>
        <label>
          GP No:
          <input
            type="text"
            className="entry"
            name="gp_no"
            value={details.gp_no}
            onChange={handleChange}
          />
        </label>
        <label>
          Invoice No:
          <input
            type="text"
            className="entry"
            name="invoice_no"
            value={details.invoice_no}
            onChange={handleChange}
          />
        </label>
        <label>
          Invoice Date:
          <input
            type="text"
            className="entry"
            name="invoice_date"
            value={details.invoice_date}
            onChange={handleChange}
          />
        </label>
        <label>
          Weight:
          <input
            type="text"
            className="entry"
            name="weight"
            value={details.weight}
            onChange={handleChange}
          />
        </label>
        <label>
          Rate Per MT (Ton):
          <input
            type="text"
            className="entry"
            name="rate_per_mt"
            value={details.rate_per_mt}
            onChange={handleChange}
          />
        </label>
        <label>
          Freight To Pay:
          <input
            type="text"
            className="entry"
            name="freight_to_pay"
            value={details.freight_to_pay}
            onChange={handleChange}
          />
        </label>
        <label>
          Advance:
          <input
            type="text"
            className="entry"
            name="advance"
            value={details.advance}
            onChange={handleChange}
          />
        </label>
        <label>
          Rate CGST & SGST:
          <input
            type="text"
            className="entry"
            name="rate_cgst_sgst"
            value={details.rate_cgst_sgst}
            onChange={handleChange}
          />
        </label>
        <label>
          Rate IGST:
          <input
            type="text"
            className="entry"
            name="rate_igst"
            value={details.rate_igst}
            onChange={handleChange}
          />
        </label>
        <label>
          Total
          <input
            type="text"
            className="entry"
            name="total"
            value={details.total}
            onChange={handleChange}
          />
        </label>
        <label>
          To Pay / Remarks
          <input
            type="text"
            className="entry"
            name="to_pay_remarks"
            value={details.to_pay_remarks}
            onChange={handleChange}
          />
        </label>
        <button
          style={{
            marginLeft: "100px",
            marginRight: "100px",
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
        >
          Submit
        </button>
      </form>
      <Printbilty details={details} />
    </div>
  );
}

export default Invoices;
